import React from "react";

const SeoHead = ({
  title = "ARTE OLIVIERI | Arte Digital e Impresiones Exclusivas",
  description = "Explora obras de arte originales, impresiones digitales y cuentos visuales en la galería virtual de ARTE OLIVIERI. Arte contemporáneo que transforma espacios.",
  keywords = "arte digital, impresiones artísticas, galería virtual, obras de arte originales, artista contemporáneo",
  ogImage = "https://images.unsplash.com/photo-1617791160505-6f00504e3519?w=1200&auto=format&fit=crop",
  ogUrl = "",
  twitterHandle = "@arteolivieri",
  canonicalUrl,
  structuredData,
}) => {
  // URL canónica por defecto si no se proporciona
  const canonical =
    canonicalUrl ||
    ogUrl ||
    (typeof window !== "undefined" ? window.location.origin : "");

  // Datos estructurados JSON-LD para artista/galería de arte
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "VisualArtwork",
    name: title,
    description: description,
    artform: "Digital Art and Fine Art Prints",
    artMedium: "Digital, Canvas, Fine Art Paper",
    creator: {
      "@type": "Person",
      name: "ARTE OLIVIERI",
    },
    artworkSurface: "Digital, Canvas, Paper",
  };

  const jsonLd = structuredData || defaultStructuredData;

  return (
    <>
      {/* Metaetiquetas básicas SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Spanish" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="ARTE OLIVIERI" />

      {/* Metaetiquetas para dispositivos móviles */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta name="theme-color" content="#0f0f0f" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta
        name="apple-mobile-web-app-status-bar-style"
        content="black-translucent"
      />

      {/* Metaetiquetas Open Graph para redes sociales */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ARTE OLIVIERI" />
      <meta property="og:locale" content="es_ES" />

      {/* Metaetiquetas Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={twitterHandle} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Prevencion de indexación de imágenes para protección */}
      <meta
        name="pinterest"
        content="nopin"
        description="Las imágenes están protegidas por derechos de autor"
      />

      {/* Metaetiquetas de seguridad SIMPLIFICADAS - eliminando las que causan problemas */}
      {/* Se eliminó la directiva Content-Security-Policy que causaba el error */}
      <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
      <meta httpEquiv="Referrer-Policy" content="no-referrer-when-downgrade" />

      {/* Datos estructurados JSON-LD para SEO avanzado */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      {/* CSS para eliminar restricciones de imagen */}
      <style>
        {`
          img {
            pointer-events: auto !important;
            user-select: auto !important;
            -webkit-user-select: auto !important;
            -moz-user-select: auto !important;
            -ms-user-select: auto !important;
            filter: none !important;
          }
          
          .image-container::after, 
          .protected-overlay, 
          .protected-layer {
            display: none !important;
          }
        `}
      </style>
    </>
  );
};

export default SeoHead;
